export default {
    inserted: function (el) {
        el.focus();
    }
};



// WEBPACK FOOTER //
// ./src/components/directives/autofocus.js